<template>
	<div>
		<CLoader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<div class="container-fluid">
					<form id="FormMcp_Destino" role="form" method="post" autocomplete="off" onSubmit="return false">
						<div class="form-group row">
							<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
								<label for="RazonSocial">Rázon Social</label>
								<div class="input-group">
									<input readonly name="RazonSocial" id="RazonSocial" type="text" class="form-control" v-model="objAgente.RazonSocial">
									<button @click="BuscarClientes()" v-if="Origen==='Finanzas'" type="button" class="btn btn-outline-primary boder-extend"><i class="far fa-search"></i></button>
								</div>
								<CValidation v-if="this.errorvalidacion.IdAgente" :Mensaje="'*'+errorvalidacion.IdAgente[0]"/>
							</div>
						</div>
						<div class="form-group row">
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label class="form-label" for="TipoDestino">Tipo Destino</label>
								<select name="TipoDestino" id="TipoDestino" class="form-control form-select" v-model="objMcp_Destino.TipoDestino" >
									<option value="">Seleccione una opción</option>
									<option value="Origen">Origen</option>
									<option value="Destino">Destino</option>
								</select>
								<!-- <input type="text" v-model="objMcp_Destino.TipoDestino" class="form-control" id="TipoDestino" placeholder="Ingresar TipoDestino" /> -->
								<CValidation v-if="this.errorvalidacion.TipoDestino" :Mensaje="'*'+errorvalidacion.TipoDestino[0]"/>
							</div>
							<div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
								<label class="form-label" for="Empresa">Empresa</label>
								<input type="text" v-model="objMcp_Destino.Empresa" class="form-control" id="Empresa" placeholder="Ingresar Empresa" />
								<CValidation v-if="this.errorvalidacion.Empresa" :Mensaje="'*'+errorvalidacion.Empresa[0]"/>
							</div>
						</div>
						
						<div class="form-group row">
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label class="form-label" for="RFC">RFC</label>
								<input type="text" v-model="objMcp_Destino.RFC" class="form-control" id="RFC" placeholder="Ingresar RFC" />
								<CValidation v-if="this.errorvalidacion.RFC" :Mensaje="'*'+errorvalidacion.RFC[0]"/>
							</div>
						
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label class="form-label" for="Calle">Calle</label>
								<input type="text" v-model="objMcp_Destino.Calle" class="form-control" id="Calle" placeholder="Ingresar Calle" />
								<CValidation v-if="this.errorvalidacion.Calle" :Mensaje="'*'+errorvalidacion.Calle[0]"/>
							</div>
	
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label class="form-label" for="NumExt">Número Exterior</label>
								<input type="text" v-model="objMcp_Destino.NumExt" class="form-control" id="NumExt" placeholder="Ingresar NumExt" />
								<CValidation v-if="this.errorvalidacion.NumExt" :Mensaje="'*'+errorvalidacion.NumExt[0]"/>
							</div>
						</div>
						
						<div class="form-group row">
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label class="form-label" for="NumInt">Número Interior</label>
								<input type="text" v-model="objMcp_Destino.NumInt" class="form-control" id="NumInt" placeholder="Ingresar NumInt" />
								<CValidation v-if="this.errorvalidacion.NumInt" :Mensaje="'*'+errorvalidacion.NumInt[0]"/>
							</div>
						
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label class="form-label" for="CodigoPostal">Código Postal</label>
								<input type="text" v-model="objMcp_Destino.CodigoPostal" class="form-control" id="CodigoPostal" placeholder="Ingresar CodigoPostal" />
								<CValidation v-if="this.errorvalidacion.CodigoPostal" :Mensaje="'*'+errorvalidacion.CodigoPostal[0]"/>
							</div>
			
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label class="form-label" for="Pais">País</label>
								<select name="Pais" id="Pais" class="form-control form-select" v-model="objMcp_Destino.Pais" @change="GetCombosUbicacion('pais')">
									<option value="">Seleccione una opción</option>
									<option v-for="(item, idx) in ListaPaises" :value="item.Clave" :key="idx">{{item.Clave}} - {{ item.Nombre }}</option>
								</select>
								<!-- <input type="text" v-model="objMcp_Destino.Pais" class="form-control" id="Pais" placeholder="Ingresar Pais" /> -->
								<CValidation v-if="this.errorvalidacion.Pais" :Mensaje="'*'+errorvalidacion.Pais[0]"/>
							</div>
						</div>
						
						<div class="form-group row">
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label class="form-label" for="Estado">Estado</label>
								<select name="Estado" id="Estado" class="form-control form-select" v-model="objMcp_Destino.Estado" @change="GetCombosUbicacion('estado')">
									<option value="">Seleccione una opción</option>
									<option v-for="(item, idx) in ListaEstados" :value="item.Clave" :key="idx">{{item.Clave}} - {{ item.Nombre }}</option>
								</select>
								<CValidation v-if="this.errorvalidacion.Estado" :Mensaje="'*'+errorvalidacion.Estado[0]"/>
							</div>
					
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label class="form-label" for="Municipio">Municipio</label>
								<select name="Municipio" id="Municipio" class="form-control form-select" v-model="objMcp_Destino.Municipio" @change="GetCombosUbicacion('municipio')">
									<option value="">Seleccione una opción</option>
									<option v-for="(item, idx) in ListaMunicipios" :value="item.Clave" :key="idx">{{item.Clave}} - {{ item.Nombre }}</option>
								</select>
								<CValidation v-if="this.errorvalidacion.Municipio" :Mensaje="'*'+errorvalidacion.Municipio[0]"/>
							</div>
					
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label class="form-label" for="Colonia">Colonia</label>
								<select name="Colonia" id="Colonia" class="form-control form-select" v-model="objMcp_Destino.Colonia" >
									<option value="">Seleccione una opción</option>
									<option v-for="(item, idx) in ListaColonias" :value="item.Clave" :key="idx">{{item.Clave}} - {{ item.Nombre }}</option>
								</select>
								<CValidation v-if="this.errorvalidacion.Colonia" :Mensaje="'*'+errorvalidacion.Colonia[0]"/>
							</div>
						</div>
						
						<div class="form-group row">
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label class="form-label" for="Localidad">Localidad</label>
								<select name="Localidad" id="Localidad" class="form-control form-select" v-model="objMcp_Destino.Localidad" >
									<option value="">Seleccione una opción</option>
									<option v-for="(item, idx) in ListaLocalidades" :value="item.Clave" :key="idx">{{item.Clave}} - {{ item.Nombre }}</option>
								</select>
								<CValidation v-if="this.errorvalidacion.Localidad" :Mensaje="'*'+errorvalidacion.Localidad[0]"/>
							</div>
					
							<div class="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
								<label class="form-label" for="Referencias">Referencias</label>
								<textarea v-model="objMcp_Destino.Referencias" class="form-control" id="Referencias" placeholder="Ingresar Referencias" rows="3"></textarea>
								<CValidation v-if="this.errorvalidacion.Referencias" :Mensaje="'*'+errorvalidacion.Referencias[0]"/>
							</div>
						</div>					
						<br>
					
					</form>
				</div>
			</template>
		</CLoader>
		<CModal :pConfigModal="ConfigModalClientes" :poBtnSave="oBtnSave">
			<template slot="Form">
				<ListClientes :poBtnSave="oBtnSave"></ListClientes>
			</template>
		</CModal>
	</div>
</template>

<script>
const EmitEjecuta = 'formCpDestinos';
import ListClientes from '@/views/catalogos/cpDestinos/ListClientes.vue';
export default {
    name: 'FormMcp_Destino',
    props: ['poBtnSave', 'pIdAgente','pOrigen'],
    components:{ListClientes},
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objMcp_Destino: {
				IdDestino: 0,
				IdAgente: '',
				TipoDestino: '',
				Empresa: '',
				RFC: '',
				Calle: '',
				NumInt: '',
				NumExt: '',
				CodigoPostal: '',
				Pais: '',
				Estado: '',
				Municipio: '',
				Colonia: '',
				Localidad: '',
				Referencias: '',
				IdUsuario: '',
            },
			ConfigModalClientes:{
                ModalTitle: "Listado de Hoteles/Empresas",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize: 'xl',
				ShowFooter: false,
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
			objAgente:{
				IdAgente: '',
                RazonSocial: '',
			},
			Origen:'',
			IdAgente:'',
			ListaPaises:[],
			ListaEstados:[],
			ListaMunicipios:[],
			ListaLocalidades:[],
			ListaColonias:[],
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
			if(this.objMcp_Destino.IdDestino == 0) {
				await this.$http.post(
					'cpDestinos',this.objMcp_Destino
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpDestinos/'+this.objMcp_Destino.IdDestino,
					this.objMcp_Destino
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpDestinos/"+this.objMcp_Destino.IdDestino
            ).then((res) => {
				this.objMcp_Destino = res.data.data;
				const resp = res.data.data;
				this.objMcp_Destino.Municipio = resp.Municipio ? resp.Municipio : '';
				this.objMcp_Destino.Localidad = resp.Localidad ? resp.Localidad : '';
				this.objMcp_Destino.Colonia = resp.Colonia ? resp.Colonia : '';

				this.$http.get("cpDataCombosUbicacion",{
					params:{
						Pais:this.objMcp_Destino.Pais,
						Estado:this.objMcp_Destino.Estado,
						Municipio:this.objMcp_Destino.Municipio,
					}
				}).then((res)=>{
					this.ListaEstados = res.data.data.ListEstado;
					this.ListaMunicipios = res.data.data.ListMunicipio;
					this.ListaLocalidades = res.data.data.ListLocalidad;
					this.ListaColonias = res.data.data.ListColonia;
				}).catch(err => console.error(err));
				if(this.objMcp_Destino.IdAgente){
					this.RecuperaCliente();
				}
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
		RecuperaCliente(){
			
			this.$http.get('agentes/'+this.objMcp_Destino.IdAgente
			).then((res) => {
				this.objAgente.RazonSocial = res.data.data.RazonSocial;
			}).catch(err => console.error(err));
		},
		GetCombosUbicacion(Tipo){
			if(Tipo==='pais'){
				this.ListaEstados = [];
				this.ListaMunicipios = [];
				this.ListaLocalidades = [];
				this.ListaColonias = [];
				this.objMcp_Destino.Estado = '';
				this.objMcp_Destino.Localidad = '';
				this.objMcp_Destino.Municipio = '';
				this.objMcp_Destino.Colonia = '';

				if(this.objMcp_Destino.Pais) {
					this.$http.get('cpEstados',{params:{
					ClavePais:this.objMcp_Destino.Pais,
					simple:true,
					}
					}).then((res)=>{
						this.ListaEstados = res.data.data;
					}).catch(err => console.error(err))
				}
			} else if(Tipo==='estado'){
				this.ListaMunicipios = [];
				this.ListaLocalidades = [];
				this.ListaColonias = [];
				this.objMcp_Destino.Localidad = '';
				this.objMcp_Destino.Municipio = '';
				this.objMcp_Destino.Colonia = '';

				if(this.objMcp_Destino.Estado){
					this.$http.get('cpLocalidades',{params:{
					ClaveEstado:this.objMcp_Destino.Estado,
					simple:true,
					}
					}).then((res)=>{
						this.ListaLocalidades = res.data.data;
					}).catch(err => console.error(err))
					this.$http.get('cpMunicipios',{params:{
					ClaveEstado:this.objMcp_Destino.Estado,
					simple:true,
					}
					}).then((res)=>{
						this.ListaMunicipios = res.data.data;
					}).catch(err => console.error(err))
				}
			} else if(Tipo==='municipio'){
				this.ListaColonias = '';
				this.objMcp_Destino.Colonia = '';
				if(this.objMcp_Destino.Municipio){
					this.$http.get('cpColonias',{params:{
						IdMunicipio:this.objMcp_Destino.Municipio,
						IdEstado:this.objMcp_Destino.Estado,
						simple:true,
					}
				}).then((res)=>{
					this.ListaColonias = res.data.data;
				}).catch(err => console.error(err))
			}
		}

		},
		GetComboPaises(){
			this.$http.get('cpPaises/',{
				params:{
					simple:true,
				}
			}).then((res)=> {
				this.ListaPaises = res.data.data;
			}).catch(err => console.error(err))
		},
		BuscarClientes(){
			this.bus.$emit('NewModal_'+EmitEjecuta);
		},
		SetCliente(obj){
			this.objAgente = obj;
			this.objMcp_Destino.IdAgente = this.objAgente.IdAgente;
		},
        Limpiar()
        {
            this.objMcp_Destino = {
				IdDestino: 0,
				IdAgente: '',
				TipoDestino: '',
				Empresa: '',
				RFC: '',
				Calle: '',
				NumInt: '',
				NumExt: '',
				CodigoPostal: '',
				Pais: '',
				Estado: '',
				Municipio: '',
				Colonia: '',
				Localidad: '',
				Referencias: '',
				IdUsuario: '',
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
		this.bus.$off('SeleccionarCliente_'+this.Emit);
		this.GetComboPaises();
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
            if(this.pIdAgente){
				this.objMcp_Destino.IdAgente = this.pIdAgente;
				this.RecuperaCliente();
			}
			if(this.pOrigen){
				this.Origen = this.pOrigen;
			}
            if (Id!='') 
            {
                this.objMcp_Destino.IdDestino = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
		this.bus.$on('SeleccionarCliente_'+EmitEjecuta, (obj)=>{
			this.SetCliente(obj);
		});
    }
}
</script>
